import React from "react"
import ReactDOM from "react-dom/client"
import { SnackbarProvider } from 'notistack';
import App from "./App"
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import './styles/recaptcha.css'; 
import ReactGA from 'react-ga4';

ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID); 

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <GoogleReCaptchaProvider
    reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
    scriptProps={{ async: true, defer: true, appendTo: 'head' }}
  >
    <SnackbarProvider maxSnack={1}>
      <App />
    </SnackbarProvider>
  </GoogleReCaptchaProvider>
);
